export const BREADCRUMB_LIST = [
  { id: "1", title: "Pedidos", active: false },
  { id: "2", title: "Alta de Disponibilidad", active: true },
]

// Colores del punto que precede a cada zona en la tabla de precios
export const ZONE_COLORS = [
  "#3b82f6",
  "#10b981",
  "#f59e0b",
  "#8b5cf6",
  "#ec4899",
  "#06b6d4",
  "#ef4444",
  "#84cc16",
]

export const MAX_RATING = 3

export const SAVED_FEEDBACK_MS = 3000
